export const FriendRequestStatus = {
	PENDING: 'PENDING',
	DECLINED: 'DECLINED',
	ACCEPTED: 'ACCEPTED',
	UNFRIENDED: 'UNFRIENDED',
};
